import { gql } from "@apollo/client"

export const CONTACT_US = gql`
  query ContactUs($payload: ContactUsPayload!) {
    contactUs(payload: $payload)
  }
`
